import React, { useContext } from "react";
import Typography from "@material-ui/core/Typography";
import ProductDetailContext from "@micado-digital/react-shop/ProductDetail/context/ProductDetailContext";
import useDescriptions from "@micado-digital/react-shop/ProductDetail/hooks/useDescriptions";
import useVintage from "../../../hooks/useVintage";
import Tag from "../Tag";

import styles from "./Information.styles";

const Information = ({ lang }) => {
	const { productDetailData } = useContext(ProductDetailContext);
	const { features, title } = productDetailData || {};
	const label = useDescriptions({ lang, type: "label" });
	const vintage = useVintage({ features });
	const { description } = label || {};
	const css = styles();

	return (
		<div className={css.container}>
			<div className={css.left}>
				{description && (
					<Typography
						className={css.overline}
						component="p"
						dangerouslySetInnerHTML={{ __html: description }}
						variant="overline"
					/>
				)}
				<Typography className={css.title} variant="h1">
					{title}
				</Typography>
				<div className={css.wrapper}>
					<div className={css.tag}>
						<Tag />
					</div>
					{vintage && <Typography className={css.vintage}>{vintage}</Typography>}
				</div>
			</div>
		</div>
	);
};

export default Information;
